import { jsx as _jsx } from "react/jsx-runtime";
import { exchangeAuthCode, fetchUserInfo } from '@repo/auth';
import { AccessDenied } from '@repo/custom-icons';
import { setAccessToken } from '@repo/token-storage';
import { ErrorContent, ErrorPageLayout, SadFaceIcon } from '@repo/ui-primitives/error-page';
import { Link, createFileRoute, redirect } from '@tanstack/react-router';
import { upsertUser } from 'ze-sdk';
import { z } from 'zod';
import { PendingComponent } from '../../pending-component';
const callbackSearchSchema = z.object({
    ze_auth_code: z.string().optional(),
    error: z.string().optional()
});
export const Route = createFileRoute('/auth/callback')({
    validateSearch: callbackSearchSchema,
    loaderDeps: (param)=>{
        let { search } = param;
        return {
            search
        };
    },
    loader: async (param)=>{
        let { deps: { search } } = param;
        const { ze_auth_code, error } = search;
        // Handle OAuth errors
        if (error) {
            throw new Response("Authentication error: ".concat(error), {
                status: 403
            });
        }
        // No auth code = invalid callback
        if (!ze_auth_code) {
            return redirect({
                to: '/login'
            });
        }
        try {
            const tokens = await exchangeAuthCode(ze_auth_code);
            await setAccessToken(tokens.access_token, tokens.refresh_token);
            const userInfo = await fetchUserInfo();
            await upsertUser({
                data: userInfo
            });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
            // Clear partial auth state
            setAccessToken(null, null);
            throw new Response('Authentication failed', {
                status: 403
            });
        }
        // Step 4: Success - redirect to intended destination
        const redirectUrl = sessionStorage.getItem('auth_redirect') || '/';
        sessionStorage.removeItem('auth_redirect');
        throw redirect({
            to: redirectUrl
        });
    },
    errorComponent: ()=>{
        return /*#__PURE__*/ _jsx("div", {
            className: "h-full w-full flex justify-center items-center",
            children: /*#__PURE__*/ _jsx(ErrorPageLayout, {
                children: /*#__PURE__*/ _jsx(ErrorContent, {
                    icon: SadFaceIcon,
                    title: "403!",
                    subtitle: "You're not authorized to access this page",
                    description: "Try to go back to the home page",
                    image: /*#__PURE__*/ _jsx(AccessDenied, {}),
                    action: /*#__PURE__*/ _jsx(Link, {
                        to: "/",
                        children: "Go to Home Page"
                    })
                })
            })
        });
    },
    pendingComponent: PendingComponent
});
